/*
 * Ki-Tax: System for the management of external childcare subsidies
 * Copyright (C) 2017 City of Bern Switzerland
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

export enum TSMitteilungStatus {
    NEU = 'NEU',
    GELESEN = 'GELESEN',
    ERLEDIGT = 'ERLEDIGT',
    IGNORIERT = 'IGNORIERT'
}

/**
 * Returns a filtered array of TSMitteilungStatus based on the provided traegerschaft flag.
 *
 * @param {boolean} traegerschaftOrInstitution - A boolean flag indicating whether to filter the statuses for "Trägerschaften" or "Institutionen".
 * @return {Array<TSMitteilungStatus>} An array of TSMitteilungStatus values based on the filter criteria.
 * Users having the role TSRole.ADMIN_TRAEGERSCHAFT or TSRole.SACHBEARBEITER_TRAEGERSCHAFT respectively "...INSTITUTION" will not see the status
 * ERLEDIGT and  IGNORIERT in the filter component.
 */
export function getTSMitteilungsStatusForFilter(
    traegerschaftOrInstitution: boolean
): Array<TSMitteilungStatus> {
    if (traegerschaftOrInstitution) {
        return [TSMitteilungStatus.NEU, TSMitteilungStatus.GELESEN];
    }

    return [
        TSMitteilungStatus.NEU,
        TSMitteilungStatus.GELESEN,
        TSMitteilungStatus.ERLEDIGT,
        TSMitteilungStatus.IGNORIERT
    ];
}
